import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Remove static crawler content after React mounts — users never see it
document.getElementById('crawler-content')?.remove();

// Register the network-first service worker (installability + offline fallback)
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* non-blocking */
    });
  });
}
